<template>
    <div class="layout-popup detail-pilun-pop">
        <ul class="detail-pilun-pop-list">
            <li class="detail-pilun-pop-item" @click="clickPiPan">
                <i class="iconfont icon-pen"></i>
                <span class="detail-ppl-title">批盘<span class="red-circle" v-if="settingConfigData.red_pipanlist == 0"></span></span>
                <span v-if="(baziNumData.pipan + baziNumData.otherpipan) != 0" class="detail-ppl-num">{{baziNumData.pipan + baziNumData.otherpipan}}</span>
            </li>
            <li class="detail-pilun-pop-item" @click="clickLunPan">
                <i class="iconfont icon-paper"></i>
                <span class="detail-ppl-title">论盘记录<span class="red-circle" v-if="settingConfigData.red_lunpanlist == 0"></span></span>
                <span v-if="baziNumData.lunpan != 0" class="detail-ppl-num">{{baziNumData.lunpan}}</span>
            </li>
            <!-- <li class="detail-pilun-pop-item" @click="clickCompare">
                <i class="iconfont icon-comp"></i>
                <span class="detail-ppl-title">对比/合八字<span class="red-circle" v-if="settingConfigData.red_duibi == 0"></span></span>
            </li> -->
            <li class="detail-pilun-pop-item" @click="clickStartDiscuss">
                <i class="iconfont icon-chat-2"></i>
                <span class="detail-ppl-title">发起在线论盘<span class="red-circle" v-if="settingConfigData.red_sendlunpan == 0"></span></span>
            </li>
        </ul>
    </div>
</template>

<script>
import { SHARE } from '../../modules/share';
import { DISCUSS_DATA_MANAGER } from '../../modules/data';
import { DISCUSS_DOM } from '../../modules/dom';
import { WS } from '../../modules/websocket';
export default {
    name: 'DetailPiLunPop',
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        baziNumData() {
            return this.$store.state.detail.baziNumData;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    methods: {
        clickPiPan() {
            this.$store.state.detail.showPipanLunpanPop = false;
            // 初始化数据:批盘数据和他人批盘的列表数据一起拉下来
            var personInfo = this.$store.state.detail.personInfo;
            console.log('点击批盘----------', personInfo)
            this.$store.dispatch('comment/initPiPan', personInfo);
            this.$store.dispatch('othercomment/getOtherPiPanList', personInfo.id);

            // 先重置，再初始化mini命盘的数据
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', personInfo);

            this.updateRedCircleStatus('pipan');
            // 页面跳转
            var me = this;
            setTimeout(() => {
                me.$router.replace('/comment/detail/' + personInfo.id);
                SHARE.initConfigShare();
            }, 10);
        },
        clickLunPan() {
            this.$store.state.detail.showPipanLunpanPop = false;
            // 初始化数据:批盘数据和他人批盘的列表数据一起拉下来
            var personInfo = this.$store.state.detail.personInfo;
            this.$store.dispatch("discuss/initLunPanList", personInfo);

            this.updateRedCircleStatus('lunpan');
            // 页面跳转
            var me = this;
            setTimeout(() => {
                me.$router.replace('/discusslist/' + personInfo.id);
                SHARE.initConfigShare();
            }, 10);
        },
        clickCompare() {
            this.$store.state.detail.showPipanLunpanPop = false;
            this.updateRedCircleStatus('compare');
        },
        clickStartDiscuss() {
            this.$store.state.detail.showPipanLunpanPop = false;
            this.updateRedCircleStatus('discuss');

            var me = this,
                personInfo = this.$store.state.detail.personInfo,
                newTitle = DISCUSS_DATA_MANAGER.getNewLunPanTitle();
            this.$store.state.discuss.detailInfo = personInfo;
            this.$store.dispatch('discuss/addNewLunPan', {
                lunpanName: newTitle,
                cb: function(data){
                    setTimeout(() => {
                        me.goToDiscussPage(data);
                    }, 100);
                }
            });
        },
        goToDiscussPage(data) {
            var me = this,
                personInfo = this.$store.state.detail.personInfo;
            // 先重置，再初始化mini命盘的数据
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', personInfo);
            // 跳转到论盘详情页面
            this.$router.replace('/discuss/discusslist/' + personInfo.id);
            // 初始化IM
            WS.initWebSocket(data.rid, function(){
                // 初始化论盘数据:聊天记录列表:websocket登录之后再拉取列表数据
                me.$store.dispatch("discuss/initLunPan", {
                    lunpanData: data,
                    cb: function() {
                        // 设置微信分享配置
                        setTimeout(() => {
                            DISCUSS_DOM.updateDiscussPageStyle();
                            DISCUSS_DOM.updateDiscussFormStyle();
                        }, 200);
                    }
                });
            });
            
            this.$store.state.discuss.lunpanData = data;
            // 配置微信分享
            setTimeout(() => {
                if(!me.fromEmbedded){
                    SHARE.initConfigShare();
                }
            }, 20);
        },
        /**
         * 上报红点状态
         */
        updateRedCircleStatus(type) {
            switch(type) {
                case 'pipan':
                    if(this.settingConfigData.red_pipanlist == 0) {
                        this.$store.dispatch('setting/updateSettingData', {
                            red_pipanlist: 1
                        })
                    }
                    break;
                case 'lunpan':
                    if(this.settingConfigData.red_lunpanlist == 0) {
                        this.$store.dispatch('setting/updateSettingData', {
                            red_lunpanlist: 1
                        })
                    }
                    break;
                case 'compare':
                    if(this.settingConfigData.red_duibi == 0) {
                        this.$store.dispatch('setting/updateSettingData', {
                            red_duibi: 1
                        })
                    }
                    break;
                case 'discuss':
                    if(this.settingConfigData.red_sendlunpan == 0) {
                        this.$store.dispatch('setting/updateSettingData', {
                            red_sendlunpan: 1
                        })
                    }
                    break;
                default:
                    break;
            }
        }
    }
}
</script>